var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"m-0 alert",class:{ sm: this.size == 'sm' },attrs:{"show":this.show,"variant":this.type}},[_vm._v(_vm._s(this.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }